import { useIsSplitEnabled } from '@buffer-mono/features'

/**
 * Gates the Composer Header's ContentItem title display and inline edit.
 * While off, the header shows only the static fallback text, same as before
 * this feature existed.
 */
export const COMPOSER_POST_TITLE_FLAG = 'geid-composer-post-title'

export function useComposerPostTitleEnabled(): boolean {
  return useIsSplitEnabled(COMPOSER_POST_TITLE_FLAG)
}
